import { render } from "./ChangeTenant.vue?vue&type=template&id=01015e91"
import script from "./ChangeTenant.vue?vue&type=script&lang=js"
export * from "./ChangeTenant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__